
import Cookies from 'js-cookie'
import Chinese from 'chinese-s2t'

const limits = {
    install (vue) {
        const langType = Cookies.get('lang')
        this.isSimpleConversion = !langType
        const fnName = langType ? 's2t' : 't2s'
        vue.prototype.langTransfer = function (pre) {
            return Chinese[fnName](pre)
        }
    }
}

export default limits
